export const PlantItemRenewalAddInspectionCertificatesPage = {
  electricalInspection: {
    title: 'Electrical inspection certificate',
    description:
      'An <a href="https://www.safework.nsw.gov.au/__data/assets/pdf_file/0003/1069824/amusement-device-electrical-inspection-certificate.pdf" target="_blank" rel="noreferrer">Electrical inspection certificate (PDF, 1.8MB)</a> must be completed by an electrician or electrical engineer.',
    competentPersonLabel: 'Full name of electrician or electrical engineer',
    competentPersonHelpText: 'This must be the person who conducted the inspection.',
    inspectionDateLabel: 'Date of inspection',
    inspectionDateErrorTitle: 'You cannot renew this item registration.',
    inspectionDateErrorText:
      'Item(s) must be inspected within 12 months of completing this renewal application.<p> If you plan to use the item, get it inspected again before you renew.</p>',
    anySpecialConditionsLabel: 'Did the electrician or electrical engineer add any special conditions?',
    describeConditionsLabel: 'Enter the special conditions',
    describeConditionsHelpText: 'You can find this information in the inspection certificate',
    supportingDocumentsLabel: 'Before you upload, check:',
    supportingDocumentsHelpText:
      '<ol><li>The documents is in English.</li><li>The image is clear and all text is legible for any scanned documents.</li><li>There is one file for each document. For example, you have scanned a multi-page document into a single file.</li></ol>',
    uploadedFileLabel: 'Uploaded electrical inspection certificate',
  },
  mechanicalInspection: {
    title: 'Mechanical/structural inspection certificate',
    description:
      'A <a href="https://www.safework.nsw.gov.au/__data/assets/pdf_file/0004/1069825/amusement-device-mechanical-structural-inspection-certificate.pdf" target="_blank" rel="noreferrer">Mechanical/structural inspection certificate (PDF, 1.8MB)</a> must be completed by a qualified engineer.',
    competentPersonLabel: 'Full name of engineer',
    competentPersonHelpText: 'This must be the person who conducted the inspection.',
    inspectionDateLabel: 'Date of inspection',
    inspectionDateErrorTitle: 'You cannot renew this item registration.',
    inspectionDateErrorText:
      'Item(s) must be inspected within 12 months of completing this renewal application.<p> If you plan to use the item, get it inspected again before you renew.</p>',
    anySpecialConditionsLabel: 'Did the engineer add any special conditions?',
    describeConditionsLabel: 'Enter the special conditions',
    describeConditionsHelpText: 'You can find this information in the inspection certificate',
    supportingDocumentsLabel: 'Before you upload, check:',
    supportingDocumentsHelpText:
      '<ol><li>The documents is in English.</li><li>The image is clear and all text is legible for any scanned documents.</li><li>There is one file for each document. For example, you have scanned a multi-page document into a single file.</li></ol>',
    uploadedFileLabel: 'Uploaded Mechanical/structural inspection certificate',
  },
};
